// Structure complète des services et produits

export const deviceBrands = {
  smartphones: ["Apple", "Samsung", "Xiaomi", "Oppo", "Vivo", "Motorola", "LG", "POCO", "ASUS", "Lenovo", "OnePlus", "Google Pixel", "Huawei", "Honor", "Realme", "Nothing"],
  tablets: ["Apple iPad", "Samsung", "Lenovo", "Huawei", "Microsoft Surface", "Xiaomi"],
  computers: ["Apple MacBook", "Asus", "Lenovo", "HP", "Dell", "Acer", "MSI", "Toshiba"],
  consoles: ["PlayStation", "Xbox", "Nintendo Switch", "Steam Deck"]
};

// RÉPARATIONS SMARTPHONES & TABLETTES
export const smartphoneTabletRepairs = [
  {
    id: "ecran",
    category: "Remplacement Écrans",
    icon: "Monitor",
    description: "Écran cassé, tactile défectueux, traces ou lignes sur l'affichage",
    brands: deviceBrands.smartphones,
    services: [
      "Remplacement vitre + LCD",
      "Réparation tactile",
      "Changement écran OLED/AMOLED",
      "Réparation écran pliable"
    ]
  },
  {
    id: "batterie-charge",
    category: "Batterie & Chargement",
    icon: "Battery",
    description: "Problèmes de charge, batterie qui se décharge rapidement",
    brands: deviceBrands.smartphones,
    services: [
      "Remplacement batterie",
      "Réparation connecteur de charge",
      "Changement port USB-C / Lightning",
      "Réparation circuit de charge"
    ]
  },
  {
    id: "son",
    category: "Son & Audio",
    icon: "Volume2",
    description: "Problèmes de son, micro, écouteurs",
    brands: deviceBrands.smartphones,
    services: [
      "Réparation haut-parleur interne",
      "Changement haut-parleur externe",
      "Réparation micro",
      "Réparation prise jack",
      "Réparation écouteur interne"
    ]
  },
  {
    id: "logiciel",
    category: "Dépannage Logiciel",
    icon: "Code",
    description: "Bugs, virus, problèmes système",
    brands: deviceBrands.smartphones,
    services: [
      "Déblocage téléphone",
      "Réinitialisation",
      "Suppression virus/malware",
      "Mise à jour système",
      "Sauvegarde et transfert de données",
      "Récupération de données"
    ]
  },
  {
    id: "camera",
    category: "Caméras",
    icon: "Camera",
    description: "Caméra avant/arrière défectueuse",
    brands: deviceBrands.smartphones,
    services: [
      "Remplacement caméra arrière",
      "Remplacement caméra avant",
      "Réparation flash",
      "Nettoyage optique"
    ]
  },
  {
    id: "boutons",
    category: "Boutons & Composants",
    icon: "Power",
    description: "Boutons défectueux, capteurs",
    brands: deviceBrands.smartphones,
    services: [
      "Réparation bouton power",
      "Réparation boutons volume",
      "Changement bouton home/empreinte",
      "Réparation capteur proximité",
      "Réparation vibreur"
    ]
  }
];

// RÉPARATIONS ORDINATEURS
export const computerRepairs = [
  {
    id: "ecran-pc",
    category: "Dalle & Écran",
    icon: "Monitor",
    description: "Écran cassé, pixels morts, dalle défectueuse",
    brands: deviceBrands.computers,
    services: [
      "Remplacement dalle LCD/LED",
      "Changement écran complet",
      "Réparation charnières",
      "Remplacement nappe écran"
    ]
  },
  {
    id: "batterie-pc",
    category: "Batterie & Alimentation",
    icon: "Battery",
    description: "Problèmes de charge, batterie HS",
    brands: deviceBrands.computers,
    services: [
      "Remplacement batterie",
      "Réparation connecteur DC",
      "Changement adaptateur secteur",
      "Réparation circuit d'alimentation"
    ]
  },
  {
    id: "connectique-pc",
    category: "Connecteurs & Ports",
    icon: "Usb",
    description: "Ports USB, HDMI, jack défectueux",
    brands: deviceBrands.computers,
    services: [
      "Réparation ports USB",
      "Changement port HDMI",
      "Réparation prise jack",
      "Réparation lecteur carte SD"
    ]
  },
  {
    id: "systeme-pc",
    category: "Système & Logiciel",
    icon: "HardDrive",
    description: "Windows, MacOS, Linux, bugs système",
    brands: deviceBrands.computers,
    services: [
      "Installation Windows/MacOS",
      "Nettoyage virus/malware",
      "Optimisation performances",
      "Récupération de données",
      "Upgrade SSD/RAM",
      "Sauvegarde complète"
    ]
  },
  {
    id: "clavier-pc",
    category: "Clavier & Trackpad",
    icon: "Keyboard",
    description: "Clavier défectueux, trackpad HS",
    brands: deviceBrands.computers,
    services: [
      "Remplacement clavier",
      "Réparation trackpad",
      "Changement touches individuelles",
      "Nettoyage clavier"
    ]
  },
  {
    id: "ventilation-pc",
    category: "Refroidissement",
    icon: "Fan",
    description: "Surchauffe, ventilateur bruyant",
    brands: deviceBrands.computers,
    services: [
      "Changement ventilateur",
      "Nettoyage complet",
      "Changement pâte thermique",
      "Déblocage ventilation"
    ]
  }
];

// AUTRES APPAREILS HIGH-TECH
export const otherDevicesRepairs = [
  {
    id: "consoles",
    category: "Consoles de Jeux",
    icon: "Gamepad2",
    description: "PlayStation, Xbox, Nintendo Switch",
    brands: deviceBrands.consoles,
    services: [
      "Réparation lecteur disque",
      "Changement port HDMI",
      "Réparation surchauffe",
      "Remplacement ventilateur",
      "Réparation alimentation",
      "Nettoyage complet"
    ]
  },
  {
    id: "manettes",
    category: "Manettes",
    icon: "Gamepad",
    description: "Manettes PlayStation, Xbox, Switch",
    brands: ["PS5", "PS4", "Xbox Series", "Xbox One", "Nintendo Switch Pro"],
    services: [
      "Réparation joystick (drift)",
      "Changement boutons",
      "Réparation gâchettes",
      "Remplacement batterie",
      "Réparation connectivité"
    ]
  },
  {
    id: "montres",
    category: "Montres Connectées",
    icon: "Watch",
    description: "Apple Watch, Samsung Galaxy Watch, etc.",
    brands: ["Apple Watch", "Samsung Galaxy Watch", "Huawei Watch", "Fitbit"],
    services: [
      "Remplacement écran",
      "Changement batterie",
      "Réparation capteurs",
      "Changement bracelet"
    ]
  }
];

// ACCESSOIRES À LA VENTE
export const accessoiresCategories = [
  {
    id: "energie",
    category: "Énergie & Chargement",
    icon: "Zap",
    products: [
      "Chargeurs muraux USB-C, Lightning, Micro-USB",
      "Câbles de charge (1m, 2m, 3m)",
      "Chargeurs rapide (Quick Charge, Power Delivery)",
      "Chargeurs sans fil (Qi)",
      "Prises secteur multi-ports",
      "Adaptateurs secteur voyage",
      "Batteries externes (10000mAh, 20000mAh, 30000mAh)",
      "Chargeurs voiture USB",
      "Stations de charge multi-appareils"
    ]
  },
  {
    id: "protection",
    category: "Protection",
    icon: "Shield",
    products: [
      "Coques iPhone (toutes modèles)",
      "Coques Samsung (toutes modèles)",
      "Coques universelles",
      "Verres trempés (9H, protection intégrale)",
      "Films de protection hydrogel",
      "Protection caméra",
      "Étuis à rabat / Folio",
      "Coques antichoc / militaire"
    ]
  },
  {
    id: "audio",
    category: "Son & Audio",
    icon: "Headphones",
    products: [
      "Écouteurs filaires jack 3.5mm",
      "Écouteurs USB-C / Lightning",
      "Écouteurs sans fil (TWS)",
      "Casques Bluetooth",
      "Casques filaires",
      "Enceintes Bluetooth portables",
      "Enceintes connectées",
      "Câbles audio jack",
      "Adaptateurs audio"
    ]
  },
  {
    id: "gaming",
    category: "Gaming",
    icon: "Gamepad2",
    products: [
      "Manettes gaming mobile",
      "Grips / poignées téléphone",
      "Refroidisseurs téléphone",
      "Supports gaming",
      "Gâchettes gaming",
      "Câbles gaming"
    ]
  },
  {
    id: "stockage",
    category: "Stockage",
    icon: "HardDrive",
    products: [
      "Cartes mémoire microSD (32GB, 64GB, 128GB, 256GB, 512GB)",
      "Cartes SD",
      "Clés USB (16GB à 256GB)",
      "Disques durs externes (500GB, 1TB, 2TB, 4TB)",
      "SSD externes",
      "Lecteurs de cartes USB"
    ]
  },
  {
    id: "connectique",
    category: "Connectique & Adaptateurs",
    icon: "Cable",
    products: [
      "Adaptateurs Lightning vers Jack",
      "Adaptateurs USB-C vers Jack",
      "Adaptateurs USB-C vers USB-A",
      "Adaptateurs USB-C vers HDMI",
      "Adaptateurs Lightning vers USB",
      "Câbles HDMI",
      "Hubs USB (4 ports, 7 ports)",
      "Hubs USB-C multi-fonctions",
      "Câbles OTG"
    ]
  },
  {
    id: "supports",
    category: "Supports & Fixations",
    icon: "Smartphone",
    products: [
      "Supports téléphone bureau",
      "Supports téléphone pliables",
      "Supports voiture (grille, pare-brise, tableau de bord)",
      "Supports magnétiques",
      "Trépieds flexibles",
      "Perches selfie",
      "Supports tablette"
    ]
  },
  {
    id: "voiture",
    category: "Accessoires Voiture",
    icon: "Car",
    products: [
      "Chargeurs allume-cigare USB",
      "Supports téléphone voiture",
      "Transmetteurs FM Bluetooth",
      "Kits mains-libres Bluetooth",
      "Câbles auxiliaire",
      "Dashcam"
    ]
  },
  {
    id: "gadgets",
    category: "Gadgets & Divers",
    icon: "Sparkles",
    products: [
      "Anneaux lumineux (ring light)",
      "Stabilisateurs smartphone",
      "Stylets capacitifs",
      "Nettoyants écran",
      "Pochettes anti-ondes",
      "PopSockets / grips",
      "Organisateurs de câbles",
      "Lampes LED USB"
    ]
  }
];

// SERVICES DÉMATÉRIALISÉS
export const servicesDigitaux = [
  {
    id: "recharges",
    category: "Recharges Téléphoniques",
    icon: "Phone",
    services: [
      "Recharges Orange",
      "Recharges SFR",
      "Recharges Bouygues Telecom",
      "Recharges Free Mobile",
      "Recharges La Poste Mobile",
      "Recharges Lebara",
      "Recharges Lycamobile",
      "Autres opérateurs MVNO"
    ]
  },
  {
    id: "forfaits",
    category: "Forfaits Prépayés",
    icon: "CreditCard",
    services: [
      "Forfaits sans engagement",
      "Cartes SIM prépayées",
      "Activation de lignes",
      "Portabilité de numéro",
      "Forfaits internationaux"
    ]
  },
  {
    id: "transferts",
    category: "Transferts Internationaux",
    icon: "Send",
    services: [
      "Transferts d'argent vers l'Afrique",
      "Transferts vers l'Asie",
      "Transferts vers l'Europe",
      "Transferts vers les Amériques",
      "Recharge mobile internationale",
      "Western Union",
      "MoneyGram",
      "Ria Money Transfer"
    ]
  },
  {
    id: "cartes",
    category: "Cartes & Codes",
    icon: "Gift",
    services: [
      "Cartes cadeaux iTunes/App Store",
      "Cartes Google Play",
      "Cartes PlayStation Network",
      "Cartes Xbox",
      "Cartes Nintendo eShop",
      "Cartes Steam",
      "Cartes Spotify",
      "Cartes Netflix"
    ]
  }
];
